export type EcommerceSaveToastSeverity = 'success' | 'error' | 'info' | 'warning';

export interface EcommerceSaveToastPayload {
  message: string;
  severity?: EcommerceSaveToastSeverity;
}

type Listener = (payload: EcommerceSaveToastPayload) => void;

let listener: Listener | null = null;

export function setEcommerceSaveToastListener(next: Listener | null): void {
  listener = next;
}

export function notifyEcommerceSaved(
  message = 'Değişiklikler kaydedildi',
  severity: EcommerceSaveToastSeverity = 'success'
): void {
  listener?.({ message, severity });
}
